var map = {
	"./1.png": 4057,
	"./2.png": 2534,
	"./3.png": 8804,
	"./4.png": 3840,
	"./5.png": 8238,
	"./6.png": 8013,
	"./7.png": 4652,
	"./8.png": 2620
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 542;